import { PartialRecord } from '@/shared/types/helpers';
import type { SxProps } from '@mui/system';
import type { Theme } from '@mui/material/styles';

export type ButtonVariant = 'contained' | 'outlined' | 'text';
export type ButtonTheme = 'main' | 'light' | 'secondary' | 'dark' | 'light' | 'mintNoHoverReaction' | 'aqua' | 'mintTwo' | 'approval';

export const buttonVariantMap: PartialRecord<ButtonVariant, PartialRecord<ButtonTheme, SxProps<Theme>>> = {
    contained: {
        secondary: {
            backgroundColor: 'primary.700',
            color: 'white',
            boxShadow: '-3px 3px 11.3px 0px #4E585636',
            '&:hover': {
                backgroundColor: 'primary.00b398'
            }
        },
        dark: {
            backgroundColor: '#004A3F',
            color: 'white',
            '&:hover': {
                backgroundColor: 'primary'
            }
        },
        main: {
            ':disabled': {
                color: 'grey.500'
            }
        },
        // Filled dark-green CTA (e.g. "Review Shipment") — white DM Sans 700 / 16px per Figma.
        approval: {
            backgroundColor: '#045F51',
            color: '#FFF',
            fontSize: '16px',
            lineHeight: '120%',
            boxShadow: '0px 4px 7.1px 0px rgba(0, 0, 0, 0.06)',
            '&:hover': {
                backgroundColor: '#045F51',
                border: 'none'
            },
            '&.Mui-disabled': {
                backgroundColor: 'rgba(4, 95, 81, 0.32)',
                color: '#FFF'
            }
        },
        light: {
            backgroundColor: 'grey.200',
            border: 0,
            color: 'primary.main',

            '&:hover': {
                backgroundColor: 'primary',
                border: 0,
                color: 'white'
            }
        },
        aqua: {
            backgroundColor: 'primary.500',
            borderColor: 'primary.500'
        }
    },
    outlined: {
        main: {
            '&:hover': {
                backgroundColor: 'primary.50',
                color: 'primary.main'
            }
        },
        light: {
            borderColor: 'white',
            color: 'white',
            '&:hover': {
                backgroundColor: 'primary',
                borderColor: 'primary'
            }
        },
        secondary: {
            backgroundColor: 'primary.50',
            color: 'primary',
            border: 'primary',
            '&:hover': {
                backgroundColor: 'primary',
                borderColor: 'primary'
            }
        },
        mintNoHoverReaction: {
            color: 'black',
            backgroundColor: '#CCE3DA',
            border: 'none',
            '&:hover': {
                backgroundColor: '#CCE3DA',
                border: 'none',
                color: 'black'
            }
        },
        mintTwo: {
            color: 'white',
            backgroundColor: '#27C6B0',
            border: 'none',
            '&:hover': {
                border: 'none'
            }
        }
    },
    text: {
        main: {
            p: '0 !important',
            borderRadius: 0,
            ':disabled': {
                color: 'grey.500'
            }
        },
        dark: {
            p: 0,
            color: 'black',
            fontWeight: 700,
            borderRadius: 0
        }
    }
};
